import useApi from '../hook/useApi';

const useRideReportApi = () => {
  const { sendRequest, loading, data, error } = useApi();


  const getRideReportData = async (page = 1, search = '', status = "") => {
    return sendRequest(`/imp/booking_reports_screen/get_all_fraud_historylist?page=${page}&search=${search}&status=${status}`, 'GET', {});
  };

  const approveRejectRideReport = async (id, payload) => {
    return sendRequest(`/imp/booking_reports_screen/edit_fraud_history/${id}`, 'PUT', payload);
  };

  const addRideReport = async (payload) => {
    return sendRequest('/booking/fraud_history/add_fraud_number', 'POST', payload);
  };

  return {
    getRideReportData,
    approveRejectRideReport,
    addRideReport,
    loading,
    data,
    error,
  };
};

export default useRideReportApi;